export default function Footer() {
  const handleScrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-background-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-400 mb-4">
                夜猫电影院
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                高清电影免费在线观看平台，提供不卡顿秒播的高清影视内容。每日更新最新电影与热门剧集，熬夜追剧的最佳免费影院。
              </p>
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500/30 transition-colors">
                  <i className="ri-weibo-line text-sm text-foreground-300"></i>
                </span>
                <span className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500/30 transition-colors">
                  <i className="ri-wechat-line text-sm text-foreground-300"></i>
                </span>
                <span className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500/30 transition-colors">
                  <i className="ri-bilibili-line text-sm text-foreground-300"></i>
                </span>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速导航</h4>
              <div className="space-y-2.5">
                {[
                  { label: '首页', href: '#hero' },
                  { label: '热门分类', href: '#cards' },
                  { label: '影片索引', href: '#index' },
                  { label: '热播排行', href: '#ranking' },
                  { label: '精彩推荐', href: '#media' },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleScrollTo(link.href); }}
                    className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer no-underline whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">平台服务</h4>
              <div className="space-y-2.5">
                {[
                  { label: '关于我们', href: '#about' },
                  { label: '联系我们', href: '#contact' },
                  { label: '常见问题', href: '#faq' },
                  { label: '最新动态', href: '#updates' },
                  { label: '观众评价', href: '#comments' },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleScrollTo(link.href); }}
                    className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer no-underline whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                更多合作伙伴正在加入中，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2023-2026 夜猫电影院. 高清电影免费在线观看不卡顿 | 免费电视剧大全不缓冲
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-400 transition-colors whitespace-nowrap">
                  用户协议
                </span>
                <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-400 transition-colors whitespace-nowrap">
                  隐私政策
                </span>
                <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-400 transition-colors whitespace-nowrap">
                  免责声明
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}